import { bffApiUrl, listingApiUrl } from "../constants/url-constants";

export default (api) => {
    const BASE_API_URL = `${listingApiUrl()}`;

    const fetchWishlistCarsList = (token) => {
        return api.get(`${BASE_API_URL}/secure/v1/shortlist/vehicles`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    };
    const addOrRemoveFromWishlist = (token, data) => {
        return api.post(`${BASE_API_URL}/secure/v1/shortlist`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    };

    const fetchWishlistCars = (token, params) => {
        const version = params.wishlistAdoptionVariant ? "api/v2" : "secure/v1";
        const baseUrl = params.wishlistAdoptionVariant ? bffApiUrl() : BASE_API_URL;
        return api.get(`${baseUrl}/${version}/shortlist`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params
        });
    };

    return {
        fetchWishlistCarsList,
        addOrRemoveFromWishlist,
        fetchWishlistCars
    };
};
